import React from 'react';
import LoadingPAW from "../../assets/gif/paw-rotate-viewport-300px.gif"

const PawLoading = (props) => {
    return (
        <img src={LoadingPAW} alt="loading" width={props.width? props.width : 28} style={{marginTop: -5}}/>
    );
};

export default PawLoading;